module.exports = {
	"de": {
		"title": "Lokaler Ladenverkauf"
	},
	"en": {
		"title": "Shops in Switzerland"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/shops/locales.json
// module id = 69
// module chunks = 0